import React from 'react';
import './Footer.css';
import { useLanguage } from '../../i18n/LanguageContext';
import Icon from '../../../assets/icono.png';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="footer" data-name="Footer" data-node-id="5:752">
      <div className="footer__container" data-name="Container" data-node-id="5:753">
        <div className="footer__content" data-name="Row" data-node-id="5:754">
          <div className="footer__inner" data-name="Row" data-node-id="5:755">
            <div className="footer__note" data-name="Footer Note" data-node-id="5:756">
              <img src={Icon} alt="icon-copyright" className="footer__icon" />
              <div className="footer__text" data-node-id="5:758">
                <p className="footer__text-p">{t('footer.copyright')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
